export type UseCategoryGetParams = {
  currentContent: Ref<UserContent>;
  section: Ref<Sections>;
  slug: Ref<string>;
  baseCategory: CategorySchema;
  isStudyContent: boolean;
  isHome: boolean;
};

export const useCategoryGetParamsStrategy = async (
  type: CategoryPageContextTypes
): Promise<UseCategoryGetParams> => {
  switch (type) {
    case CategoryPageContextTypes.AssessmentForm:
      return await useCategoryGetParamsAssessmentForm();
    case CategoryPageContextTypes.AssessmentRun:
      return await useCategoryGetParamsAssessmentRun();
    // case CategoryPageContextTypes.AssessmentRunQuiz:
    // case CategoryPageContextTypes.AssessmentRunPost:
    //   return await useCategoryGetParamsAssessmentRunFromRoute();
    default:
      return await useCategoryGetParamsFromRoute(type);
  }
};
